import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentoUploadHelper {
  addDocumentItem() {
    throw new Error('Method not implemented.');
  }

  constructor() {}
  getNameFile(name: string): any {
    if (name && name.length > 10) return name.slice(0, 30) + '...';
    else return name;
  }

  downloadDocument(index: number, listaDocumentos?: any) {
    // Cria um elemento <a> para simular o download.
    const link = document.createElement('a');
    // Obtém os dados do arquivo a partir da lista de documentos com o índice fornecido.

    const fileData = listaDocumentos[index];
    // Define o atributo 'href' do link para a URL ou dados do arquivo.
    if (fileData && fileData.document) {
      link.href = fileData.document;
    }

    link.href = fileData.data;
    // Verifica se os dados do arquivo começam com 'data:', indicando que é uma URL base64.
    if (fileData.data && fileData.data.startsWith('data:')) {
      // Converte os dados base64 para um objeto Blob.
      const blob = this.dataURItoBlob(fileData.data);
      // Cria uma URL temporária para o objeto Blob.
      const url = window.URL.createObjectURL(blob);
      // Define o atributo 'href' do link para a URL do Blob.
      link.href = url;
      // Define o atributo 'download' do link com o nome do arquivo ou o valor padrão 'file'.
      link.download = fileData.fileName || 'documento' + Date.now;
      // Adiciona o link ao corpo do documento.
      document.body.appendChild(link);
      // Inicia o download do arquivo, clicando no link programaticamente.
      link.click();
      // Revoga a URL do objeto Blob para liberar memória após o download.
      window.URL.revokeObjectURL(url);
      // Remove o link do corpo do documento após o download.
      document.body.removeChild(link);
    } else {
      // Caso não seja uma URL base64, abre o link em uma nova guia.
      link.target = '_blank';
      link.click();
    }
  }

  dataURItoBlob(dataURI: string): Blob {
    // Decodifica a string base64 removendo o prefixo 'data:'.
    const byteString = atob(dataURI.split(',')[1]);
    // Extrai a parte do tipo MIME do cabeçalho 'data:'.
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // Cria um ArrayBuffer com o tamanho correspondente aos dados decodificados.
    const arrayBuffer = new ArrayBuffer(byteString.length);
    // Cria uma exibição de bytes (Uint8Array) do ArrayBuffer.
    const uint8Array = new Uint8Array(arrayBuffer);
    // Preenche o Uint8Array com os bytes da string decodificada.
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    // Cria um novo objeto Blob a partir do ArrayBuffer com o tipo MIME adequado.
    return new Blob([arrayBuffer], {type: mimeString});
  }

  getFileFormatFromFileName(fileName: string): string | null {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex !== -1 && dotIndex < fileName.length - 1) {
      return fileName.substring(dotIndex + 1).toLowerCase();
    }
    return null;
  }
  //pega o nome e o formato do arquivo para download

  getFileInfoFromUrl(url: any) {
    const urlParts = url.split('/');
    const filename = urlParts[urlParts.length - 1];
    const name = filename.split('.')[0];
    const extension = filename.split('.').pop();

    return {
      name,
      // size,
      format: extension ? extension : 'Desconhecido',
    };
  }

  getFileSizeFromUrl(url: string | URL) {
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', url, false);
    xhr.send();
    if (xhr.status === 200) {
      const contentLength = xhr.getResponseHeader('content-length');
      if (contentLength !== null) {
        return parseInt(contentLength, 10);
      }
    }
    return -1;
  }

  dataURLtoFile(dataURL: string, fileName: string, format: string): File {
    let byteCharacters;
    // Verificar se a string está codificada corretamente em base64 e contém o separador correto
    if (dataURL.indexOf(';base64,') !== -1) {
      // Extrair os dados do Data URL
      const dataSplit = dataURL.split(',');
      if (dataSplit.length !== 2) {
        throw new Error('Invalid Data URL format');
      }
      byteCharacters = atob(dataSplit[1]);
    } else {
      // Se não estiver codificado em base64, use os próprios dados
      byteCharacters = unescape(encodeURIComponent(dataURL));
    }

    // Extrair o tipo do arquivo do Data URL
    const typeMatch = dataURL.match(/^data:(.*?);base64,/);
    if (!typeMatch) {
      // throw new Error("Invalid Data URL format");
    }

    const fileType = 'application/' + format;

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: fileType});

    // Criar um novo objeto File a partir do Blob
    const newFile = new File([blob], fileName, {type: fileType});
    return newFile;
  }

  //  converter base64 para PDF
  base64ToPdf(base64Data: string, fileName: string = 'documento.pdf'): File {
    // Remove o cabeçalho do base64 se existir (data:application/pdf;base64,)
    const base64Clean = base64Data.replace(
      /^data:application\/\w+;base64,/,
      '',
    );

    // Converte base64 para array de bytes
    const byteCharacters = atob(base64Clean);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Cria o array de bytes
    const byteArray = new Uint8Array(byteNumbers);

    // Cria o blob com tipo PDF
    const blob = new Blob([byteArray], {type: 'application/pdf'});

    // Retorna um objeto File
    return new File([blob], fileName, {type: 'application/pdf'});
  }

  //converte de Base64 para ulrPDF
  visualizarPDFUrl(base64: string): string {
    try {
      // Verifica se a string está no formato correto de Data URL
      if (base64.indexOf(';base64,') !== -1) {
        // Extrai apenas a parte base64 após a vírgula
        const base64Limpo = base64.split(';base64,')[1];

        // Converte base64 para array de bytes
        const byteCharacters = atob(base64Limpo);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Cria o blob do PDF
        const blob = new Blob([byteArray], {type: 'application/pdf'});

        // Retorna a URL para visualização
        return URL.createObjectURL(blob);
      } else if (base64.startsWith('http')) {
        // Se for uma URL direta, retorna ela mesma
        return base64;
      } else {
        // Tenta decodificar a string base64 diretamente
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: 'application/pdf'});
        return URL.createObjectURL(blob);
      }
    } catch (error) {
      console.error('Erro ao processar o PDF:', error);
      return '';
    }
  }

  public _ehImagemUrl(url: string): boolean {
    return /\.(jpeg|jpg|png|gif|bmp|webp|svg)$/i.test(url);
  }
}
